<template>
    <div class="tabbar-wrapper">
        <div
            v-for="(item, index) in items"
            :key="'tabitem' + index"
            :style="{ width: 100 / items.length + 'vw' }"
            @click="tab(index)"
        >
            <i class="el-input__icon tabbar-icon" :class="['el-icon-' + item.icon]" :style="activeItem(index)"></i>
            <span class="d-block tabbar-item-title" :style="activeItem(index)">{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabBar',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        showSelection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentIndex: 0,
        };
    },
    computed: {},
    methods: {
        tab(index) {
            this.$emit('tab', index);
            this.currentIndex = index;
        },
        activeItem(index) {
            if (this.showSelection) {
                return { color: this.currentIndex === index ? '#1e398f' : 'black' };
            }
            return {};
        },
    },
};
</script>

<style scoped></style>
